import{a as r}from"./chunk.2AIXLGYE.js";import{a as o}from"./chunk.NFEB7TIJ.js";import{a as n}from"./chunk.XPINZPW5.js";import{a as h}from"./chunk.65JZXZ5X.js";import{c as a}from"./chunk.NWIV65VP.js";import{property as s,state as g}from"lit/decorators.js";import{html as f,literal as d,unsafeStatic as m}from"lit/static-html.js";import{css as p}from"lit";var l=p`
  ${r}

  :host {
    color: var(--he-type-primary);
  }

  :host([tag='span']) {
    display: inline;
  }

  :host(:not([tag='span'])) {
    display: block;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    margin: 0;
  }

  :host(:is([appearance='heading-1'], [appearance='hero-title'])) {
    font-family: var(--he-heading-font);
    font-size: var(--he-font-size-5x-large);
    font-weight: var(--he-heading-font-weight);
    line-height: var(--he-line-height-5x-large);
  }

  :host(:is([appearance='heading-2'], [appearance='greeting-title'])) {
    font-family: var(--he-heading-font);
    font-size: var(--he-font-size-4x-large);
    font-weight: var(--he-heading-font-weight);
    line-height: var(--he-line-height-4x-large);
  }

  :host(:is([appearance='heading-3'], [appearance='email-header'])) {
    font-family: var(--he-heading-font);
    font-size: var(--he-font-size-3x-large);
    font-weight: var(--he-heading-font-weight);
    line-height: var(--he-line-height-3x-large);
  }

  :host(:is([appearance='heading-4'], [appearance='pane-header'])) {
    font-family: var(--he-heading-font);
    font-size: var(--he-font-size-2x-large);
    font-weight: var(--he-heading-font-weight);
    line-height: var(--he-line-height-2x-large);
  }

  :host(:is([appearance='heading-5'], [appearance='header'])) {
    font-family: var(--he-heading-font);
    font-size: var(--he-font-size-x-large);
    font-weight: var(--he-heading-font-weight);
    line-height: var(--he-line-height-x-large);
  }

  :host(:is([appearance='heading-6'], [appearance='subject-title'])) {
    font-family: var(--he-heading-font);
    font-size: var(--he-font-size-large);
    font-weight: var(--he-heading-font-weight);
    line-height: var(--he-line-height-large);
  }

  :host(:is([appearance='paragraph'], [appearance='body-text'])) {
    font-size: var(--he-font-size-medium);
    font-weight: var(--he-font-weight-normal);
    line-height: var(--he-line-height-medium);
  }

  :host(:is([appearance='small'], [appearance='metadata'])) {
    display: inline;
    font-size: var(--he-font-size-small);
    font-weight: var(--he-font-weight-normal);
    line-height: var(--he-line-height-small);
  }

  :host([appearance='label']) {
    display: block;
    font-size: var(--he-font-size-medium);
    line-height: var(--he-line-height-medium);
    font-weight: var(--he-font-weight-semibold);
    margin-bottom: var(--he-spacing-2x-small);
  }

  :host([appearance='menu-item-heading']) {
    color: var(--he-accent-foreground-rest);
    font-weight: var(--he-font-weight-semibold);
    border: var(--he-form-control-border-width) solid transparent;
    padding: var(--he-spacing-2x-small) var(--he-spacing-x-small);
  }

  @media screen and (forced-colors: active) {
    :host {
      color: ${o.CanvasText};
    }
  }
`;var c=["h1","h2","h3","h4","h5","h6","p","span"],e=class extends h{tagChanged(){/^h[1-6]$/.test(this.tag)?(this.setAttribute("role","heading"),this.setAttribute("aria-level",this.tag.slice(1))):(this.removeAttribute("role"),this.removeAttribute("aria-level"))}render(){let i=c.find(t=>t===this.tag);if(i){let t=d`${m(i)}`;return f`
        <${t}>
          <slot></slot>
        </${t}>
      `}return f`<slot></slot>`}};e.styles=l,e.baseName="text",e.reactEvents={},a([g()],e.prototype,"headingLevel",2),a([g()],e.prototype,"role",2),a([s({reflect:!0})],e.prototype,"appearance",2),a([s({reflect:!0})],e.prototype,"tag",2),a([n("tag")],e.prototype,"tagChanged",1);var C=e;export{e as a,C as b};
